import { z } from "zod";

import { defineEvents } from "~/analytics/factory";

/**
 * Analytics events for the account creation wizard (/onboard).
 * Namespace: "onboarding-wizard"
 * All events include `step` so we can see exactly where users drop off.
 */
export const events = defineEvents("onboarding-wizard", {
  /** User lands on the intro screen and the wizard starts. */
  started: z.object({}),

  /** User clicked "Let's go" on the intro screen. */
  intro_completed: z.object({}),

  /** User successfully passed validation and advanced to the next step. */
  step_completed: z.object({
    /** The step the user just completed: "account" | "contact" | "store" */
    from_step: z.string(),
    /** The step the user is advancing to */
    to_step: z.string(),
  }),

  /** User clicked "Previous" to go back to the prior step. */
  step_back: z.object({
    from_step: z.string(),
    to_step: z.string(),
  }),

  /** User failed step validation (clicked Next but errors remained). */
  step_validation_failed: z.object({
    step: z.string(),
  }),

  /** User clicked "Start" on the finish screen to submit the account. */
  submit_started: z.object({
    /** Whether the session will redirect to a Shopify returnUrl after creation */
    has_return_url: z.boolean(),
    industry: z.string().optional(),
    currency: z.string().optional(),
    timezone: z.string().optional(),
    role: z.string().optional(),
  }),

  /** Account creation API call succeeded. */
  submit_succeeded: z.object({
    account_id: z.string(),
    has_return_url: z.boolean(),
  }),

  /** Account creation API call failed. */
  submit_failed: z.object({
    has_return_url: z.boolean(),
  }),
});

export type Events = typeof events;
